<template>
	<div>
		<b-form-radio-group
			v-model="selected"
			:name="'items-' + group.id"
			stacked
			@change="onSelectItem"
		>
			<b-form-radio :value="null">Keine Einschränkung</b-form-radio>
			<b-form-radio
				v-for="item in group.items"
				:key="item.fuzzyType"
				:value="item"
				class="mt-4"
			>
				<span>{{ getFuzzyTypeLabel(item) }} ({{ item.count }})</span>
				<span v-if="item.info" class="d-block mt-1">
					{{ item.info }}
				</span>
			</b-form-radio>
		</b-form-radio-group>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup";
import Icon from "@/vue/icon/Icon";
import * as FuzzyType from "@/helper/characteristic/fuzzy/Type";
import {mapMutations, mapState} from "vuex";

export default {
	components: {
		RadioGroup,
		Icon,
	},

	props: {
		group: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			selected: null
		};
	},

	mounted ()
	{
		const item = _.find(this.filterGroups || [], item =>
		{
			return item.group.id === this.group.id;
		});

		if (item)
		{
			this.selected = _.find(this.group.items, i => i.fuzzyType === item.fuzzyType) || null;
		}
	},

	computed: {
		...mapState('jobProfile/fuzzyMatrix', [
			'filterGroups'
		]),
	},

	methods: {
		...mapMutations('jobProfile/fuzzyMatrix', [
			'setFilterGroups'
		]),
		getFuzzyTypeLabel (item)
		{
			return FuzzyType.getLabel(item.fuzzyType);
		},
		onSelectItem (item)
		{
			let filterGroups = _.cloneDeep(this.filterGroups);

			filterGroups = _.filter(filterGroups, item => item.group.id !== this.group.id);

			if (item)
			{
				filterGroups.push({
					group: this.group,
					fuzzyType: item.fuzzyType
				});
			}

			this.setFilterGroups(filterGroups);
		},
	},
}
</script>
